import {
  surveyExecOnAccent,
  surveyExecPrimary,
} from '@/features/instrument-onboarding/styles/surveyExecutionStyles'

/** Matches survey submit success modal — redeem celebration dialog. */
export const redeemSuccessDialogPaperSx = {
  width: '100%',
  maxWidth: '448px',
  m: 2,
  borderRadius: '10px',
  overflow: 'hidden',
  boxShadow:
    '0px 20px 12.5px rgba(0, 0, 0, 0.1), 0px 8px 5px rgba(0, 0, 0, 0.1)',
} as const

export const redeemSuccessDialogContentSx = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  p: 0,
} as const

export const redeemSuccessIconWrapSx = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',
  pt: '32px',
  pb: 0,
  boxSizing: 'border-box',
} as const

export const redeemSuccessAnimationSx = {
  objectFit: 'contain',
} as const

export const redeemSuccessTitleSx = {
  m: 0,
  px: 3,
  pt: 0,
  pb: 0,
  fontFamily: 'Inter, sans-serif',
  fontWeight: 700,
  fontSize: '20px',
  lineHeight: '28px',
  letterSpacing: '-0.4492px',
  color: '#23262f',
  textAlign: 'center',
} as const

export const redeemSuccessBodySx = {
  m: 0,
  px: 3,
  pt: 1.5,
  pb: 0,
  fontFamily: 'Inter, sans-serif',
  fontWeight: 400,
  fontSize: '14px',
  lineHeight: '22.75px',
  letterSpacing: '-0.1504px',
  color: '#4a5565',
  textAlign: 'center',
} as const

export const redeemSuccessActionsSx = {
  display: 'flex',
  justifyContent: 'center',
  width: '100%',
  px: { xs: 3, sm: '150px' },
  py: 3,
  boxSizing: 'border-box',
} as const

export const redeemSuccessOkButtonSx = {
  minWidth: '148px',
  minHeight: '40px',
  px: 2,
  py: 1.5,
  borderRadius: '12px',
  fontFamily: 'Inter, sans-serif',
  fontWeight: 600,
  fontSize: '14px',
  lineHeight: '16px',
  textTransform: 'none',
  bgcolor: surveyExecPrimary,
  color: surveyExecOnAccent,
  boxShadow: 'none',
  '&:hover': {
    bgcolor: surveyExecPrimary,
    color: surveyExecOnAccent,
    boxShadow: 'none',
  },
} as const
